import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box, Container, Paper, Typography, TextField, Button, Alert, CircularProgress } from '@mui/material';
import { HeaderV2, FooterV2 } from '../../components/layout';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { API_BASE_URL } from '../../config/api';
import { persistSession } from '../../store/slices/authSlice';

const LoginPageV2 = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [form, setForm] = useState({
    email: location.state?.email || location.state?.phone || '',
    password: location.state?.pin || '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const infoMessage = location.state?.info || '';

  useEffect(() => {
    if (location.state?.email || location.state?.phone) {
      setForm((prev) => ({
        ...prev,
        email: location.state.email || location.state.phone || prev.email,
        password: location.state.pin || prev.password,
      }));
    }
  }, [location.state]);
  
  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    
    try {
      const response = await axios.post(`${API_BASE_URL}/auth/login`, form);
      const accessToken = response.data.accessToken || response.data.token;
      const user = response.data.user;
      if (!accessToken) {
        throw new Error('No access token returned from login');
      }

      dispatch(
        persistSession({
          accessToken,
          refreshToken: response.data.refreshToken,
          user: user || { email: form.email },
        })
      );

      const returnTo = location.state?.returnTo;
      navigate(returnTo || '/v2/dashboard');
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed. Please check your credentials.');
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <Box sx={{ backgroundColor: 'background.default', minHeight: '100vh' }}>
      <HeaderV2 />
      <Container maxWidth="sm" sx={{ py: 6 }}>
        <Paper sx={{ p: 4 }} component="form" onSubmit={handleSubmit}>
          <Typography variant="h4" sx={{ fontWeight: 700, mb: 2 }}>Sign in</Typography>
          {infoMessage && <Alert severity="info" sx={{ mb: 2 }}>{infoMessage}</Alert>}
          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          <TextField
            label="Email or Phone Number"
            name="email"
            type="text"
            required
            fullWidth
            sx={{ mb: 2 }}
            value={form.email}
            onChange={handleChange}
            helperText="You can use your email address or phone number"
          />
          <TextField
            label="Password or Tracking PIN"
            type="password"
            name="password"
            required
            fullWidth
            sx={{ mb: 2 }}
            value={form.password}
            onChange={handleChange}
          />
          <Button type="submit" variant="contained" fullWidth disabled={loading}>
            {loading ? <CircularProgress size={24} /> : 'Login'}
          </Button>
          <Button onClick={() => navigate('/v2/register')} sx={{ mt: 1 }} fullWidth variant="text">
            Don't have an account? Register
          </Button>
        </Paper>
      </Container>
      <FooterV2 />
    </Box>
  );
};

export default LoginPageV2;
